import React, { useRef } from 'react';

import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'

import Spacer from '../../../app/common/ui/Spacer';
import Button from '@material-ui/core/Button'

const CreateReferrerContent = ({ referrer, onSubmit }) => {
    const { email, name, phone } = referrer;
    const emailRef = useRef(email);
    const nameRef = useRef(name);
    const phoneRef = useRef(phone);

    return (
        <React.Fragment>
            <Typography variant="h6" color="initial">Create a new Referrer</Typography>
            <Typography variant="subtitle1" color="textSecondary">Use this page to create referrers who can't or won't sign themselves up to TICIT</Typography>
            <Spacer space="0.5rem" />
            <Grid container direction="column" spacing={1}>
                <Grid item xs={12} md={4}>
                    <TextField
                        id="email"
                        label="Email Address"
                        helperText="The individual referrer's email address"
                        inputRef={emailRef}
                        defaultValue={email}
                        onChange={() => { referrer.email = emailRef.current?.value || '' }}
                        fullWidth
                        required
                    />
                </Grid>
                <Spacer space="0.5rem" />
                <Grid item xs={12} md={4}>
                    <TextField
                        id="name"
                        label="Referrer Name"
                        helperText="The name of the individual referrer"
                        inputRef={nameRef}
                        defaultValue={name}
                        onChange={() => { referrer.name = nameRef.current?.value || '' }}
                        fullWidth
                        required
                    />
                </Grid>
                <Spacer space="0.5rem" />
                <Grid item xs={12} md={4}>
                    <TextField
                        id="phone"
                        label="Phone Number"
                        helperText="Contact number for the individual referrer"
                        inputRef={phoneRef}
                        defaultValue={phone}
                        onChange={() => { referrer.phone = phoneRef.current?.value || '' }}
                        fullWidth
                    />
                </Grid>
                <Spacer space="0.5rem" />
                <Grid item xs={12} md={4}>
                    <Button
                        onClick={onSubmit}
                        variant="contained"
                        color="secondary">
                        Next
                    </Button>
                </Grid>
            </Grid>
        </React.Fragment>
    );
};

export default CreateReferrerContent;